module.exports = __webpack_public_path__ + "static/media/panda.d009e410.jpg";